import { render, staticRenderFns } from "./LgFinderPageTipoOrgao.vue?vue&type=template&id=50a8ab50"
import script from "./LgFinderPageTipoOrgao.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoOrgao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports